import React, { useEffect, createElement } from 'react';
import { SalesPage } from './pages/SalesPage';
export function App() {
  useEffect(() => {
    // Set page title
    document.title = 'Rescate Herbáceo S.O.S.';
    // Meta Pixel Code
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '871359405780071');
      fbq('track', 'PageView');
      fbq('track', 'ViewContent');
    `;
    document.head.appendChild(script);
    // noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=871359405780071&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
    // AddToCart tracking on all button/link clicks
    const trackScript = document.createElement('script');
    trackScript.innerHTML = `
      document.addEventListener("DOMContentLoaded", function() {
        const botones = document.querySelectorAll("button, a");
        botones.forEach(function(boton){
          boton.addEventListener("click", function(){
            if (typeof fbq !== "undefined") {
              fbq('track', 'AddToCart');
            }
          });
        });
      });
    `;
    document.body.appendChild(trackScript);
    return () => {
      document.head.removeChild(script);
      document.body.removeChild(noscript);
      document.body.removeChild(trackScript);
    };
  }, []);
  return <SalesPage data-id="element-0" />;
}